import React, { useEffect, useState } from "react";
import Aside from "../../components/aside/aside.component";
import Header from "../../components/header/header.component";
import Footer from "../../components/footer/footer.component";
import style from "../../components/aside/aside.module.scss";
import styleDummy from "./select-period.module.scss";
import Modal from "../../components/modal/modal.component";
import Button from "../../components/button/button.component";
import { useForm } from "react-hook-form";
import SelectComponent from "../../components/select/select.component";
import { CyclesService } from "../../services/cycles";
import { StorageService } from "../../services/storage";
import { STORAGE } from "../../constants";
import { useNavigate } from "react-router-dom";
import usePeriod from "../../hooks/period.use";

function SelectPeriodPage() {
  const navigate = useNavigate();
  const { currentPeriod } = usePeriod();
  
  const [show, setShow] = useState(false);
  const [periods, setPeriods] = useState<any[]>([]);

  const defaultValues = {
    period: "",
  };

  const {
    watch,
    setValue,
    reset,
    register,
    handleSubmit,
    formState: { errors, isSubmitting, isValid },
  } = useForm<typeof defaultValues>({
    mode: "onChange",
    defaultValues,
  });

  const submit = async (form: typeof defaultValues) => {
    StorageService.save(STORAGE.PERIOD, periods.find( p => p._id === form.period));
    navigate('/');
  };

  const getPeriods = async () => {
    const data = await CyclesService.list();
    setPeriods(data.filter( (p: any) => p.status));
  };

  useEffect(() => {
    getPeriods();
    setTimeout(() => setShow(true));

    return () => {
      
      const body = document.getElementsByTagName('body')[0];
      body.style.overflow = "auto";
      body.classList.remove('modal-open');
    }
  }, []);

  useEffect(() => {
    setValue("period", currentPeriod? currentPeriod._id : "");
  }, [periods]);

  return (
    <>
      <div className="d-flex flex-column flex-root">
        <div className="page d-flex flex-row flex-column-fluid">
          <div
            className={"aside aside-default aside-hoverable " + style.Aside}
            data-kt-drawer="true"
            data-kt-drawer-activate="{default: true, lg: false}"
            data-kt-drawer-direction="start"
            data-kt-drawer-name="aside"
            data-kt-drawer-overlay="true"
            data-kt-drawer-toggle="#kt_aside_toggle"
            data-kt-drawer-width="{default:'200px', '300px': '250px'}"
            id="kt_aside"
          >
            <div
              className="aside-logo flex-column-auto px-10 pt-9 pb-5"
              id="kt_aside_logo"
            >
              <a href="#">
                <img
                  alt="Logo"
                  className="max-h-50px logo-default theme-light-show lz"
                  src="/assets/media/logos/logo-default.svg"
                />
                <img
                  alt="Logo"
                  className="max-h-50px logo-default theme-dark-show"
                  src="/assets/media/logos/logo-default-dark.svg"
                />
                {/* <img
                  alt="Logo"
                  className="max-h-50px logo-minimize"
                  src="/assets/media/logos/logo-minimize.svg"
                /> */}
              </a>
            </div>
            <div className="aside-menu flex-column-fluid ps-3 pe-1">
              <div
                className="menu menu-sub-indention menu-column menu-rounded menu-title-gray-600 menu-icon-gray-500 menu-active-bg menu-state-primary menu-arrow-gray-500 fw-semibold fs-6 my-5 mt-lg-2 mb-lg-0"
                data-kt-menu="true"
                id="kt_aside_menu"
              >
                <div
                  className="hover-scroll-y mx-4"
                  data-kt-scroll="true"
                  data-kt-scroll-activate="{default: false, lg: true}"
                  data-kt-scroll-dependencies="#kt_aside_logo, #kt_aside_footer"
                  data-kt-scroll-height="auto"
                  data-kt-scroll-offset="20px"
                  data-kt-scroll-wrappers="#kt_aside_menu"
                  id="kt_aside_menu_wrapper"
                >
                  <div className="menu-item pt-5">
                    <div className="menu-content">
                      <div className={styleDummy.textDummy}></div>
                    </div>
                  </div>
                  <div className="menu-item">
                    <div className="d-flex align-items-center">
                      <div className={styleDummy.iconDummy}></div>
                      <div className={styleDummy.textDummy}></div>
                    </div>
                  </div>
                  <div className="menu-item">
                    <div className="d-flex align-items-center">
                      <div className={styleDummy.iconDummy}></div>
                      <div className={styleDummy.textDummy}></div>
                    </div>
                  </div>
                  <div className="menu-item">
                    <div className="d-flex align-items-center">
                      <div className={styleDummy.iconDummy}></div>
                      <div className={styleDummy.textDummy}></div>
                    </div>
                  </div>
                  <div className="menu-item">
                    <div className="d-flex align-items-center">
                      <div className={styleDummy.iconDummy}></div>
                      <div className={styleDummy.textDummy}></div>
                    </div>
                  </div>
                  <div className="menu-item">
                    <div className="d-flex align-items-center">
                      <div className={styleDummy.iconDummy}></div>
                      <div className={styleDummy.textDummy}></div>
                    </div>
                  </div>
                  <div className="menu-item">
                    <div className="d-flex align-items-center">
                      <div className={styleDummy.iconDummy}></div>
                      <div className={styleDummy.textDummy}></div>
                    </div>
                  </div>

                  <div className="menu-item pt-5">
                    <div className="menu-content">
                      <div className={styleDummy.textDummy}></div>
                    </div>
                  </div>

                  <div className="menu-item">
                    <div className="d-flex align-items-center">
                      <div className={styleDummy.iconDummy}></div>
                      <div className={styleDummy.textDummy}></div>
                    </div>
                  </div>
                  <div className="menu-item">
                    <div className="d-flex align-items-center">
                      <div className={styleDummy.iconDummy}></div>
                      <div className={styleDummy.textDummy}></div>
                    </div>
                  </div>
                  <div className="menu-item">
                    <div className="d-flex align-items-center">
                      <div className={styleDummy.iconDummy}></div>
                      <div className={styleDummy.textDummy}></div>
                    </div>
                  </div>
                  <div className="menu-item">
                    <div className="d-flex align-items-center">
                      <div className={styleDummy.iconDummy}></div>
                      <div className={styleDummy.textDummy}></div>
                    </div>
                  </div>
                  <div className="menu-item">
                    <div className="d-flex align-items-center">
                      <div className={styleDummy.iconDummy}></div>
                      <div className={styleDummy.textDummy}></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="wrapper d-flex flex-column flex-row-fluid"
            id="kt_wrapper"
          >
            <Header />
            <div
              className="content fs-6 d-flex flex-column flex-column-fluid"
              id="kt_content"
            >
              <div className="toolbar" id="kt_toolbar">
                <div className="container-fluid d-flex flex-stack flex-wrap flex-sm-nowrap">
                  <div className="d-flex flex-column align-items-start justify-content-center flex-wrap me-2">
                    <div
                      className={styleDummy.textDummy}
                      style={{ width: "250px" }}
                    ></div>
                    <ul className="breadcrumb fw-semibold fs-base my-1">
                      <li className="breadcrumb-item text-muted">
                        <div
                          className={styleDummy.textDummy}
                          style={{ width: "100px" }}
                        ></div>
                      </li>
                      <li className="breadcrumb-item text-gray-900">
                        <div
                          className={styleDummy.textDummy}
                          style={{ width: "100px" }}
                        ></div>
                      </li>
                    </ul>
                  </div>
                  <div className="d-flex align-items-center flex-nowrap text-nowrap py-1">
                    <button
                      className="btn btn-primary"
                      style={{ width: "150px" }}
                    ></button>
                  </div>
                </div>
              </div>

              <div className="post fs-6 d-flex flex-column-fluid" id="kt_post">
                <div className="container-xxl">
                  <div className="card">
                    <div className="card-body py-4">
                      <div style={{ height: "500px" }}>
                        <div
                          className={styleDummy.textDummy}
                          style={{ marginBottom: "24px", width: "100%" }}
                        />
                        <div
                          className={styleDummy.textDummy}
                          style={{ marginBottom: "24px", width: "50%" }}
                        />
                        <div
                          className={styleDummy.textDummy}
                          style={{ marginBottom: "24px", width: "50%" }}
                        />
                        <div
                          className={styleDummy.textDummy}
                          style={{ marginBottom: "24px", width: "85%" }}
                        />
                        <div
                          className={styleDummy.textDummy}
                          style={{ marginBottom: "24px", width: "25%" }}
                        />
                        <div
                          className={styleDummy.textDummy}
                          style={{ marginBottom: "24px", width: "100%" }}
                        />
                        <div
                          className={styleDummy.textDummy}
                          style={{ marginBottom: "24px", width: "50%" }}
                        />
                        <div
                          className={styleDummy.textDummy}
                          style={{ marginBottom: "24px", width: "50%" }}
                        />
                        <div
                          className={styleDummy.textDummy}
                          style={{ marginBottom: "24px", width: "85%" }}
                        />
                        <div
                          className={styleDummy.textDummy}
                          style={{ marginBottom: "24px", width: "25%" }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </div>

      <Modal className="modal-dialog-centered" show={show}>
        <div className="modal-body text-center">
          <img
            src="/assets/media/logos/oc-project-development.svg"
            className="img-fluid w-50"
          />
          <h2 className="mt-5">Selecciona una cuenta</h2>
          <p className="mb-5">
            Para trabajar en nuestra plataforma es necesario seleccionar un
            periodo o negocio, lo que permitirá acceder a las funciones y
            herramientas específicas de ese periodo o negocio en particular,
            asegurando una experiencia de usuario personalizada y eficiente.
          </p>

          <div className="mb-5">
            <SelectComponent
              label=""
              data={periods.map((row) => ({ value: row._id, text: row.name }))}
              {...register("period", { required: true })}
              errors={errors.period}
            />
          </div>
        </div>
        <div className="modal-footer">
          <Button
            className="btn btn-primary"
            disabled={!isValid}
            isLoading={isSubmitting}
            onClick={handleSubmit(submit)}
          >
            Seleccionar periodo
          </Button>
        </div>
      </Modal>
    </>
  );
}

export default SelectPeriodPage;
